import React from 'react';
import { If, PreImg } from 'common/src/components';
import { IProps, Type, SystemType } from './interface';
import emptyImgMap from './imageMap';
import '../../styles/listBlankV1.scss';
import './index.scss';
import { getCurrentSystem } from '@umu/ukit-lang';

export default function ListBlankM(props: IProps) {
    const { type, blankImg = '', className = '', title = '', desc = '', children, buttonEvent, buttonText } = props;
    const renderV1 = () => {
        return (
            <div className={`list-blank-v1 ${className}`}>
                <If condition={!!blankImg}>
                    <PreImg>
                        <img className="list-blank-img" src={blankImg} />
                    </PreImg>
                </If>
                <div className="list-blank-text">
                    <If condition={!!title}>
                        <p className="list-blank-title">{title}</p>
                    </If>
                    <If condition={!!desc}>
                        <p className="list-blank-desc">{desc}</p>
                    </If>
                    {children ? children : null}
                </div>
            </div>
        );
    };

    const getUrl = (type: Type) => {
        if (!emptyImgMap[type]) {
            return renderV1();
        }
        const currentSystem = getCurrentSystem().toLocaleLowerCase() as SystemType;
        const isOrientalArea = ['cn', 'tw', 'co'].includes(getCurrentSystem().toLocaleLowerCase());
        if (emptyImgMap[type][currentSystem]) {
            return emptyImgMap[type][currentSystem];
        }
        return isOrientalArea ? emptyImgMap[type].cn : emptyImgMap[type].com;
    };

    const renderV2 = () => {
        if (!type) {
            return renderV1();
        }
        const url = getUrl(type);
        return (
            <div className={`list-blank-mobile ${className}`}>
                <img className="list-blank-img" src={url} />
                <div className="list-blank-text">
                    {title ? <p className="list-blank-title">{title}</p> : null}
                    {desc ? <p className="list-blank-desc"> {desc}</p> : null}
                </div>
                {buttonEvent ? (
                    <div className="list-blank-operation">
                        <div className="operation-button" onClick={buttonEvent}>
                            {buttonText}
                        </div>
                    </div>
                ) : null}
                {children ? children : null}
            </div>
        );
    };

    return renderV2();
}
